
import Vue from "vue";
import vnavbar from "./components/shared/VNavbar.vue";
import vfooter from "./components/shared/VFooter.vue";
import { mapMutations, mapState } from "vuex";
import router from "./router";
import { getDeviceUuid } from "./services/deviceUuid";
import { HubConnectionBuilder } from "@microsoft/signalr";

export default Vue.extend({
  components: {
    vnavbar,
    vfooter
  },
  beforeUpdate() {
    this.$http
      .get("Perfil/isLogin", {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
      .then(res => {
        if (
          !res.data &&
          router.currentRoute.name !== "nuevoUsuario" &&
          router.currentRoute.name !== "inicio"
        ) {
          router.push("login");
        }
      });
  },
  beforeMount() {
    this.anadirLocalStorageAlStore();

    this.$http
      .get("Registra", {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
      .then(res => {
        if(res.data.tieneEntrada){
          this.$toast.open({
            message: "Tienes una entrada registrada",
            type: "is-warning",
            position: "is-bottom"
          });
        }
      });
  },
  computed: {
    ...mapState(["jwt"])
  },
  methods: {
    ...mapMutations(["anadirLocalStorageAlStore"])
  }
});
